import { toast } from "sonner";
import { api, ERROR_TEXT } from "@/lib/api";

export async function openPortal() {
  try {
    const { data } = await api.post("/billing/portal", { origin_url: window.location.origin });
    window.location.href = data.url;
  } catch {
    toast.error(ERROR_TEXT);
  }
}

export async function startCheckout(planId, interval) {
  const { data } = await api.post("/payments/checkout", { plan_id: planId, interval, origin_url: window.location.origin });
  window.location.href = data.checkout_url;
}
